import {MAP_PLACE_FIELDS} from '../../../maps/placeFields';
import { gql } from 'apollo-boost';
import { QUOTED_URL_META_FIELDS } from '../../fragments/message/quoted-url-meta-fields';
import { STRUCTURED_CONTENT_FIELDS } from '../../fragments/message/structured-content-fields';
import { TRANSCRIPT_FIELDS } from '../../fragments/message/transcript-fields';
import { FOLDER_CACHE_SAFE_FIELDS } from '../../fragments/folder/cache-safe-folder-fields';

export const FILTER_MESSAGES = gql`
    query($data: FilterMessagesInput!) {
        filterMessages(data: $data) {
            messages {
                locations {${MAP_PLACE_FIELDS}}
                id
                clientRequestId
                parentMessageId
                referencedMessageId
                threadRootMessageId
                email { subject from receivedAt preview hasOriginalHtml }
                laneKind
                aiRole
                sharingStatus { id shareCount isPublished }
                threadReplyCount
                threadChatCount
                inChatSession
                activityAt
                threadMessageCount
                threadChatUpdatedAt
                threadMessageUpdatedAt
                threadActivityUpdatedAt
                title
                body
                createdAt
                updatedAt
                reminderAt
                eventArtifactId
                event { startDate endDate startTime endTime timeZone location rawDate needsReview }
                reminderUpdatedAt
                reminderFiredAt
                reminderCancelledAt
                reminderVersion
            reminderDeliveryType
            reminderMessage
            automaticReminderNeedsReview
                dueAt
                dueTimezone
                dueKind

                dueSeriesEndAt
                alerts {
                    id
                    offsetMinutes
                    deliveryType
                    firedAt
                }
                deletedAt
                lastViewedAt
                lastMovedAt
                image {
                    url
                    cdn_url
                    thumbnail {
                        sm
                        md
                        lg
                        xl
                        original
                        compressed {
                            sm
                            md
                            lg
                            xl
                            original
                        }
                    }
                    name
                    displayName
                    type
                    format
                    size
                    width
                    height
                    aspect_ratio
                    public_id
                }
                file {
                    url
                    cdn_url
                    thumbnail {
                        sm
                        md
                        lg
                        xl
                        original
                        compressed {
                            sm
                            md
                            lg
                            xl
                            original
                        }
                    }
                    name
                    displayName
                    type
                    format
                    size
                    width
                    height
                    aspect_ratio
                    duration
                    mime
                }
                isCheckbox
                isChecked
                isStarred
                metadata {
                    highlight {
                        color
                        highlightId
                    }
                }
                folder {
                ...FolderCacheSafeFields
            }
                urlMeta {
                    place {${MAP_PLACE_FIELDS}}
                    author
                    date
                    description
                article_url
                article_body
                article_pull_provider
                reddit_comments {
                    author
                    body
                    score
                    created_utc
                    permalink
                }
                sourcePlatform
                sourceMetrics {
                    score
                    upvoteRatio
                    commentCount
                    createdUtc
                    viewCount
                    likeCount
                    shareCount
                    saveCount
                    engagementRate
                }
                sourcePlatformMeta {
                    reddit {
                        subreddit
                        permalink
                        over18
                        locked
                        stickied
                        postHint
                        isGallery
                    }
                }
                    image
                    gallery_images
                    gallery {
                        type
                        image
                        image_name
                        media {
                            public_id
                            url
                            cdn_url
                            name
                            displayName
                            type
                            format
                            size
                            aspect_ratio
                            width
                            height
                            mime
                            duration
                            ocrText
                        }
                        width
                        height
                        aspect_ratio
                        media_url
                        media_name
                        media_cdn_url
                        media_hls_url
                        media_duration
                        media_has_audio
                    }
                    image_cdn_url
                    image_name
                    media_url
                    media_type
                    media_width
                    media_height
                    media_duration
                    media_has_audio
                    media_audio_url
                    media_hls_url
                    logo
                    publisher
                    title
                    url
                    public_id
                    width
                    height
                    format
                    aspect_ratio
                    size
                    thumbnail {
                        sm
                        md
                        lg
                        xl
                        original
                        compressed {
                            sm
                            md
                            lg
                            xl
                            original
                        }
                    }
                    author_image
                    author_image_cdn_url
                    author_image_public_id
                    author_image_name
                    author_image_size
                    author_image_format
                    author_image_aspect_ratio
                    author_image_width
                    author_image_height
                    author_image_original
                    author_image_thumbnail {
                        sm
                        md
                        lg
                        xl
                        original
                        compressed {
                            sm
                            md
                            lg
                            xl
                            original
                        }
                    }
                    ${QUOTED_URL_META_FIELDS}
                }
                suggestedFolderTitle
                caption
                ${TRANSCRIPT_FIELDS}
                ${STRUCTURED_CONTENT_FIELDS}
                entities {
                    type
                    name
                    confidence

                    enrichment {
                        image
                        width
                        height
                        aspect_ratio
                        description
                        year
                        url
                        source

                    }

                }
                keywords
                ocrText
            }
            cursor
            appliedSearchMode
        }
    }
    ${FOLDER_CACHE_SAFE_FIELDS}
`;